import styled, { css } from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  width: 100%;
  height: fit-content;
  max-width: ${({ maxWidth }) => maxWidth || "320px"};
  min-width: 320px;

  color: ${({ theme }) => theme.colors.neutral.white};
  font-family: ${({ theme }) => theme.font.fontFamily};
  font-size: 16px;
  font-weight: 400;
  line-height: 20px;

  * {
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .react-select__control {
    border-radius: 0px;
  }

  .react-select__indicators {
    background-color: ${({ theme }) => theme.colors.neutral.cinza900};
  }

  .react-select__single-value,
  .react-select__input-container,
  .react-select__input {
    color: ${({ theme, variant }) =>
      variant === "light"
        ? theme.colors.neutral.cinza900
        : theme.colors.neutral.white} !important;
  }

  .react-select__option {
    color: ${({ theme }) => theme.colors.neutral.black} !important;
  }

  .react-select__option--is-selected {
    background-color: ${({ theme }) => theme.colors.primary.blue};
    color: ${({ theme }) => theme.colors.neutral.white} !important;
  }
`;

// const LabelFont = (size) => {
//   switch (size) {
//     case "xs":
//     case "sm":
//     case "md":
//       return css`
//         font-size: 16px;
//         line-height: 19.52px;
//       `;
//     case "lg":
//     default:
//   }
// };

export const Label = styled.label`
  color: ${({ theme }) => theme.colors.neutral.white};
  font-family: ${({ theme }) => theme.font.fontFamily};
  font-size: 16px;
  font-weight: 400;
  line-height: 18px;
  width: fit-content;

  ${({ required }) => {
    if (required) {
      return css`
        &::after {
          position: absolute;
          top: 0;
          right: -8px;
          content: "";
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background-color: ${({ theme }) =>
            theme.colors.feedbackState.critical.default};
        }
      `;
    }
  }}
`;

export const Select = styled.select`
  width: 100%;
  height: 32px;
`;

export const CustomStyles = (theme, size, alertType, disabled) => ({
  control: (base, state) => {
    const style = {
      ...base,
      fontWeight: "400",
      overflow: "hidden",
      height: "fit-content",
      borderRadius: "0px",
    };

    if (state.isFocused || state.isSelected) {
      style.border = `border: 1.5px solid ${theme.colors.primary.prim200}`;
    }

    switch (alertType) {
      case "error":
        style.border = `1px solid ${theme.colors.feedbackState.critical.default}`;
        break;
      case "success":
        style.border = `1px solid ${theme.colors.feedbackState.success.default}`;
        break;
      case "warning":
        style.border = `1px solid ${theme.colors.feedbackState.warning.default}`;
        break;
      default:
        style.border = `1px solid ${theme.colors.neutral.cinza900}`;
    }

    if (disabled) {
      style.opacity = 0.5;
    }

    switch (size) {
      case "xs":
        style.fontSize = "12px";
        style.lineHeight = "130%";
        style.height = "32px";
        break;
      case "sm":
        style.fontSize = "14px";
        style.lineHeight = "146%";
        style.height = "44px";
        break;
      default:
      case "md":
        style.fontSize = "16px";
        style.lineHeight = "150%";
        style.height = "48px";
        break;
      case "lg":
        style.fontSize = "20px";
        style.lineHeight = "120%";
        style.height = "56px";
        break;
    }

    return style;
  },

  valueContainer: (base) => {
    const style = {
      ...base,
      padding: "0",
      margin: "0",
      height: "fit-content",
      flex: 1,
      flexWrap: "nowrap",
      width: "max-content",
      overflowY: "hidden",
      overflowX: "auto",
      gap: "4px",
      borderRadius: "0px",
      backgroundColor: theme.colors.neutral.cinza900,
    };

    switch (size) {
      case "xs":
        style.padding = "8px";
        break;
      case "sm":
        style.padding = "12px";
        break;
      default:
      case "md":
        style.padding = "12px";
        break;
      case "lg":
        style.padding = "16px";
        break;
    }

    return style;
  },

  input: (base) => {
    const style = {
      ...base,
      padding: "0",
      margin: "0",
      borderRadius: "0px",
    };

    return style;
  },

  indicatorSeparator: (base) => {
    const style = {
      ...base,
      display: "none",
    };

    return style;
  },

  dropdownIndicator: (base) => {
    const style = {
      ...base,
      color: theme.colors.neutral.white,
      padding: "0",
      backgroundColor: theme.colors.neutral.cinza900,
    };

    switch (size) {
      case "xs":
        style.paddingRight = "8px";
        break;
      case "sm":
        style.paddingRight = "12px";
        break;
      default:
      case "md":
        style.paddingRight = "12px";
        break;
      case "lg":
        style.paddingRight = "16px";
        break;
    }

    if (disabled) {
      style.color = theme.colors.neutral.gray4;
    }

    switch (size) {
      case "xs":
        style.svg = {
          width: "16px",
          height: "16px",
        };
        break;
      case "sm":
        style.svg = {
          width: "20px",
          height: "20px",
        };
        break;
      default:
      case "md":
        style.svg = {
          width: "24px",
          height: "24px",
        };
        break;
      case "lg":
        style.svg = {
          width: "24px",
          height: "24px",
        };
        break;
    }

    return style;
  },

  placeholder: (base) => {
    const style = {
      ...base,
      color: theme.colors.neutral.cinza300,
      fontWeight: "300",
    };

    return style;
  },

  multiValue: (base) => {
    const style = {
      ...base,
      width: "max-content",
      minWidth: "min-content",
      height: "min-content",
      margin: "0",
      backgroundColor: "rgb(147, 147, 147)",
      borderRadius: "0px",
    };

    switch (size) {
      case "xs":
        style.height = "16px";
        break;
      case "sm":
        style.height = "20px";
        break;
      default:
      case "md":
        style.height = "24px";
        break;
      case "lg":
        style.height = "24px";
        break;
    }

    return style;
  },

  multiValueLabel: (base) => {
    const style = {
      ...base,
      textOverflow: "none",
    };

    switch (size) {
      case "xs":
        style.fontSize = "12px";
        style.lineHeight = "100%";
        break;
      case "sm":
        style.fontSize = "14px";
        style.lineHeight = "100%";
        break;
      default:
      case "md":
        style.fontSize = "16px";
        style.lineHeight = "130%";
        break;
      case "lg":
        style.fontSize = "20px";
        style.lineHeight = "100%";
        break;
    }

    return style;
  },
});
